// External modules
import acHTTPClient from 'services/ACHTTPClient';
import * as moment from 'moment';

// Internal modules
import * as constants from '../constants';
import config from '../../../config/config';
import { onAuthError } from '../auth';

// TODO: Use SSM
const experienceAPIURL = `${config.experienceAPIURL}/api/v1`;
const limit = config.limit.routes || config.limit.default;

const getRoutesErrored = (error) => {
  return {
    type: constants.GET_ROUTES_ERROR,
    error,
  };
};

const getRoutesSuccess = (routes) => {
  return {
    type: constants.GET_ROUTES_SUCCESS,
    routes,
  };
};

const getRoutes = (filterParams) => {
  let apiURL = `${experienceAPIURL}/routes?limit=${limit}`;
  if (filterParams) {
    apiURL += '&' + filterParams.slice(1);
  }
  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getRoutesErrored(response.statusText));
        }
        dispatch(getRoutesSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getRoutesErrored(error));
      });
  };
};

const getRouteError = (error) => {
  return {
    type: constants.GET_ROUTE_ERROR,
    error,
  };
};

const getRouteSuccess = (route) => {
  return {
    type: constants.GET_ROUTE_SUCCESS,
    route: route,
  };
};

const getRoute = (routeId) => {
  let apiURL = `${experienceAPIURL}/routes/${routeId}`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getRouteError(response.statusText));
        }
        dispatch(getRouteSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getRouteError(error));
      });
  };
};

const getRoutesByProductIdError = (error) => {
  return {
    type: constants.GET_ROUTES_BY_PRODUCT_ID_ERROR,
    error,
  };
};

const getRoutesByProductIdSuccess = (routes) => {
  return {
    type: constants.GET_ROUTES_BY_PRODUCT_ID_SUCCESS,
    routes: routes,
  };
};

const getRoutesByProductId = (productId) => {
  let apiURL = `${experienceAPIURL}/routes?productId=${productId}&status=active&status=inactive`;

  return (dispatch) => {
    const config = { url: apiURL, method: 'GET' };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(getRoutesByProductIdError(response.statusText));
        }
        dispatch(getRoutesByProductIdSuccess(response.data));
      })
      .catch((error) => {
        dispatch(getRoutesByProductIdError(error));
      });
  };
};

const patchRouteError = (error) => {
  return {
    type: constants.PATCH_ROUTE_ERROR,
    error,
  };
};

const patchRouteSuccess = (route) => {
  return {
    type: constants.PATCH_ROUTE_SUCCESS,
    route: route,
  };
};

const patchRoute = (route) => {
  let apiURL = `${experienceAPIURL}/routes/${route.id}`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PATCH', data: route };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(patchRouteError(response.statusText));
        }
        dispatch(patchRouteSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(patchRouteError(error));
      });
  };
};

const putStopError = (error) => {
  return {
    type: constants.PUT_STOP_ERROR,
    error,
  };
};

const putStopSuccess = (route) => {
  return {
    type: constants.PUT_STOP_SUCCESS,
    route: route,
  };
};

const putStops = (routeId, stops) => {
  let apiURL = `${experienceAPIURL}/routes/${routeId}/stops`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'PUT', data: stops };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(putStopError(response.statusText));
        }
        dispatch(putStopSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(putStopError(error));
      });
  };
};

const postRouteError = (error) => {
  return {
    type: constants.POST_ROUTE_ERROR,
    error,
  };
};

const postRouteSuccess = (newId) => {
  return {
    type: constants.POST_ROUTE_SUCCESS,
    newId: newId,
  };
};

const postRoute = (newRoute) => {
  let apiURL = `${experienceAPIURL}/routes`;
  return (dispatch) => {
    const config = { url: apiURL, method: 'POST', data: newRoute };
    acHTTPClient
      .request(config)
      .then((response) => {
        if (!response.data || response.data.error) {
          dispatch(postRouteError(response.statusText));
        }
        dispatch(postRouteSuccess(response.data));
      })
      .catch((error) => {
        onAuthError(error);
        dispatch(postRouteError(error));
      });
  };
};

const uploadRouteIntroductionSuccess = (route) => {
  return {
    type: constants.UPLOAD_ROUTE_INTRODUCTION_SUCCESS,
    route,
  };
};

const uploadRouteIntroductionError = (error) => {
  return {
    type: constants.UPLOAD_ROUTE_INTRODUCTION_ERROR,
    error,
  };
};

const uploadRouteIntroduction = (fileList) => {
  return async function (dispatch) {
    try {
      const file = fileList[0];
      let fileName = `${moment().format('YYYY-MM-DD-HH-mm-ss')}-${file.name}`;
      let url = `${experienceAPIURL}/routes/upload?name=${fileName}`;

      const config = {
        url: url,
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        data: file,
      };

      acHTTPClient
        .request(config)
        .then((response) => {
          if (!response.data || response.data.error) {
            dispatch(uploadRouteIntroductionError(response.statusText));
          }
          const data = {
            uploadData: response.data.data,
          };
          dispatch(uploadRouteIntroductionSuccess(data));
        })
        .catch((error) => {
          dispatch(uploadRouteIntroductionError(error));
        });
    } catch (error) {
      onAuthError(error);
      let errObj = error;
      // map it to error object
      if (typeof errObj === 'string') {
        errObj = new Error(errObj);
      }
      return dispatch(uploadRouteIntroductionError(errObj));
    }
  };
};

const clearRouteError = () => {
    return {
        type : constants.CLEAR_ROUTE_ERROR,
    }
};


export {
  getRoutes,
  getRoute,
  getRoutesByProductId,
  patchRoute,
  postRoute,
  putStops,
  uploadRouteIntroduction,
  clearRouteError
};
